import React, { useMemo } from 'react';
import { useProducts } from '../../contexts/ProductsContext';
import './Filters.css';

const SIZE_ORDER = ['PP', 'P', 'M', 'G', 'GG', 'XG', 'XXL'];

const sortSizes = (sizes) =>
  [...sizes].sort((a, b) => SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b) || a.localeCompare(b));

const Filters = ({
  showColors = false,
  showSizes = false,
  activeFilters = { sizes: [], colors: [], categories: [] },
  onToggleFilter = () => {},
}) => {
  const { products } = useProducts();

  const { sizes, colors, categories } = useMemo(() => {
    const sizeSet = new Set();
    const colorSet = new Set();
    const categorySet = new Set();
    products.forEach((p) => {
      (p.sizesAvailable || []).forEach((s) => sizeSet.add(s));
      const color = p.metadata?.color;
      if (color) colorSet.add(color);
      const category = p.metadata?.category;
      if (category) categorySet.add(category);
    });
    return {
      sizes: sortSizes([...sizeSet]),
      colors: [...colorSet].sort(),
      categories: [...categorySet].sort(),
    };
  }, [products]);

  const getSizeCount = (size) =>
    products.filter((p) => (p.sizesAvailable || []).includes(size)).length;
  const getColorCount = (color) =>
    products.filter((p) => p.metadata?.color === color).length;
  const getCategoryCount = (category) =>
    products.filter((p) => p.metadata?.category === category).length;

  const isActive = (type, value) =>
    (activeFilters[type] || []).includes(value);

  return (
    <aside className="filters-sidebar">
      {categories.length > 0 && (
        <div className="filters-section">
          <h2 className="filters-title">
            <span className="filters-icon">☰</span>
            Categorias
          </h2>
          <div className="filters-list">
            {categories.map((category) => (
              <div
                key={category}
                className={`filter-item ${isActive('categories', category) ? 'filter-item--active' : ''}`}
                onClick={() => onToggleFilter('categories', category)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && onToggleFilter('categories', category)}
              >
                <span>{category}</span>
                <span className="filter-count">{getCategoryCount(category)}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {showColors && colors.length > 0 && (
        <div className="filters-section">
          <h2 className="filters-title">
            <span className="filters-icon">🎨</span>
            Cores
          </h2>
          <div className="filters-list">
            {colors.map((color) => (
              <div
                key={color}
                className={`filter-item ${isActive('colors', color) ? 'filter-item--active' : ''}`}
                onClick={() => onToggleFilter('colors', color)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && onToggleFilter('colors', color)}
              >
                <span>{color}</span>
                <span className="filter-count">{getColorCount(color)}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {showSizes && sizes.length > 0 && (
        <div className="filters-section">
          <h2 className="filters-title">
            <span className="filters-icon">📏</span>
            Tamanhos
          </h2>
          <div className="filters-list">
            {sizes.map((size) => (
              <div
                key={size}
                className={`filter-item ${isActive('sizes', size) ? 'filter-item--active' : ''}`}
                onClick={() => onToggleFilter('sizes', size)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && onToggleFilter('sizes', size)}
              >
                <span>{size}</span>
                <span className="filter-count">{getSizeCount(size)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </aside>
  );
};

export default Filters;
